/* @flow */
import React, { Component } from 'react';
import { Record } from 'immutable';

type OptionShape = {
  mailto: string,
  subject: string,
  body: string,
};

const defaultEmailTemplate = Record({
  mailto: '',
  subject: '',
  body: '',
});

export const makeEmailForHref = (option: OptionShape): string => {
  const email = defaultEmailTemplate(option);
  return `mailto:${email.get('mailto')}?subject=${email.get('subject')}&body=${email.get('body')}`;
};

type MailToLinkProps = {
  children?: Object,
  mailto: string,
  subject: string,
  body: string,
  shouldEmail: boolean,
  className: string,
};

export class MailToLink extends Component {
  props: MailToLinkProps

  handleClick = (e: SyntheticEvent) => {
    if (!this.props.shouldEmail) {
      e.preventDefault();
    }
  };

  render() {
    const { mailto = '', subject = '', body = '' } = this.props;
    const className = this.props.className;
    return (
      <a
        href={makeEmailForHref({
          mailto,
          subject,
          body,
        })}
        className={className}
        onClick={this.handleClick}>
        {this.props.children}
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/MailToLink.js